import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, ViewEncapsulation } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { SpacerComponent } from 'src/app/common/components/spacer/spacer.component';
import { ApiCallInjectDirective } from 'src/app/common/directives/api-call-inject.directive';
import { ApiSignal, toApiSignal } from 'src/app/common/util/api-signal';
import { ShadowStylesDirective } from 'src/boilerplate/shadow-styles.directive';
import { fallbackContactImage } from 'src/environments/environment';
import { ContactDepartment, ContactsService } from '../../../openapi-client';

@Component({
  selector: 'wct-profile-contacts',
  standalone: true,
  imports: [CommonModule, SpacerComponent, TranslocoModule, ApiCallInjectDirective],
  templateUrl: './profile-contacts.component.html',
  styleUrls: ['./profile-contacts.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  hostDirectives: [ShadowStylesDirective],
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class ProfileContactsComponent {
  protected readonly contacts: ApiSignal<ContactDepartment[]> = toApiSignal(inject(ContactsService).loadContacts());
  protected readonly fallbackImage: string = fallbackContactImage;
}
